import { getClassDisplayText } from './instructorClassWorkflows';

export const HIDDEN_INSTRUCTOR_CALENDAR_STATUSES = new Set(['4', '5', '7', '8']);

const pad2 = (value) => String(value).padStart(2, '0');

export const getLocalDateKey = (date) => {
  if (!date) return '';
  return [
    date.getFullYear(),
    pad2(date.getMonth() + 1),
    pad2(date.getDate()),
  ].join('-');
};

export const getLAClassDateKey = (dateMs) => {
  const timestamp = Number(dateMs);
  if (!Number.isFinite(timestamp)) return '';

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(timestamp));

  const year = parts.find((part) => part.type === 'year')?.value;
  const month = parts.find((part) => part.type === 'month')?.value;
  const day = parts.find((part) => part.type === 'day')?.value;

  return year && month && day ? `${year}-${month}-${day}` : '';
};

export const getVisibleInstructorCalendarClasses = (classes = []) => (
  classes.filter((classData) => (
    !HIDDEN_INSTRUCTOR_CALENDAR_STATUSES.has(String(classData?.classStatus))
  ))
);

export const hasClassCompletionStatus = (classData = {}) => (
  ['1', '2'].includes(String(classData.status ?? '').trim())
);

export const getInstructorCalendarStatus = (classData = {}, nowMs = Date.now()) => {
  if (hasClassCompletionStatus(classData)) return 'complete';

  const endMs = Number(classData.EndDate || classData.Date || 0);
  if (Number.isFinite(endMs) && endMs < Number(nowMs)) return 'needs-attention';

  return 'upcoming';
};

export const getInstructorCalendarColorScheme = (classData = {}, nowMs = Date.now()) => {
  const status = getInstructorCalendarStatus(classData, nowMs);

  if (status === 'complete') {
    return {
      status,
      label: 'Complete',
      bg: '#EDF2F7',
      color: '#2D3748',
      borderColor: '#A0AEC0',
    };
  }

  if (status === 'needs-attention') {
    return {
      status,
      label: 'Needs Attention',
      bg: '#FFF5F5',
      color: '#9B2C2C',
      borderColor: '#E53E3E',
    };
  }

  return {
    status,
    label: 'Upcoming',
    bg: '#E6F6ED',
    color: '#22543D',
    borderColor: '#38A169',
  };
};

export const getInstructorCalendarClassesForDate = (classes = [], date) => {
  const targetDateKey = getLocalDateKey(date);
  if (!targetDateKey) return [];

  return getVisibleInstructorCalendarClasses(classes)
    .filter((classData) => getLAClassDateKey(classData?.Date) === targetDateKey)
    .sort((a, b) => Number(a?.Date || 0) - Number(b?.Date || 0));
};

export const formatClassTimeLA = (dateMs) => {
  const timestamp = Number(dateMs);
  if (!Number.isFinite(timestamp)) return '';

  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(timestamp));
};

export const getInstructorCalendarClassTitle = (classData = {}) => (
  getClassDisplayText(classData.ClassName || classData.ClassType, 'Class')
);
